import script from "./SearchInputNew.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInputNew.vue?vue&type=script&setup=true&lang=js"

import "./SearchInputNew.vue?vue&type=style&index=0&id=fc9280f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc9280f6"]])

export default __exports__